export const MESSAGING_POLL_INTERVAL_MS = 15_000;
